<template>
  <v-container fluid class="pa-0 bm-form-element-row">
    <v-row>
      <v-col cols="12" :md="fullWidth ? 12 : 8">
        <slot
          :on="generateEventListeners()"
          :t="t"
          :tooltip="isTwoColumnView && hintTextOrTooltip ? '' : undefined"
        ></slot>
      </v-col>
    </v-row>
    <div v-if="isTwoColumnView" class="bm-column-hint">
      <bm-column-hint
        :active-field="isHintActive"
        :empty="!hintTextOrTooltip || hintTextOrTooltip.length === 0"
      >
        {{ hintTextOrTooltip }}
      </bm-column-hint>
    </div>
  </v-container>
</template>

<script setup lang="ts">
import BmColumnHint from "@/components/controls/wizard/BmColumnHint.vue";
import Guid from "@/app/types/common/guid";
import Key from "@/app/types/common/key";
import { translate } from "@/plugins/i18n";
import type { WizardRegistry } from "./useWizardRegistry";
import { screenSize } from "@/vue23switching/screenSize";
import { computed } from "vue";

interface BmWizardFormElementProps {
  wizardRegistry: WizardRegistry;
  t?: Key;
  fullWidth?: boolean;
}

const props = withDefaults(defineProps<BmWizardFormElementProps>(), {
  fullWidth: false,
});

const hintId = Guid.create();

const hintTextOrTooltip = computed(
  () => translate(Key.fromString(props.t?.value + "_hint")) || undefined
);

const isTwoColumnView = computed(() => screenSize.mdAndUp && !props.fullWidth);

const isHintActive = computed(
  () => props.wizardRegistry.activeHint?.equals(hintId) ?? false
);

const generateEventListeners = () => {
  return {
    focus: () => {
      if (hintTextOrTooltip.value) {
        props.wizardRegistry.pushHint(hintId);
      }
    },
    blur: () => {
      if (hintTextOrTooltip.value) {
        props.wizardRegistry.popHint(hintId);
      }
    },
  };
};
</script>

<style scoped lang="sass">
.bm-form-element-row
  position: relative

div.bm-column-hint
  position: absolute
  left: 66.666666%
  z-index: 2
  top: 0
</style>
